import useTeams from '@hooks/useTeams';
import { isTeamCoach } from '@utils/shared-utils';
import AdminTeamView from './TeamCoachView';
import TeamOverview from './TeamOverview';
import { Box, CircularProgress, Grid2 as Grid, Typography } from '@mui/material';
import { useParams } from 'react-router';
import { useEffect } from 'react';

export default function TeamDetails() {
    const { loading, role, selectedTeam, setSelectedTeam, teams } = useTeams();

    const params = useParams<{ teamId: string | undefined }>();

    // TODO: move to route guard blocker/loading?
    // get team from route
    useEffect(() => {
        const foundTeam = teams?.find(({ teamId }) => teamId === params.teamId);
        if (foundTeam) {
            setSelectedTeam(foundTeam);
        }
    }, [params.teamId, setSelectedTeam, teams]);

    const isCoach = isTeamCoach(role);

    // if no team selected, show a message
    if (!selectedTeam) {
        return (
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                style={{ height: '90vh', width: '100%' }}
            >
                <Grid>
                    <Typography variant="h5">Please select a team to view team details</Typography>
                </Grid>
            </Grid>
        );
    }

    if (loading) {
        return (
            <Box sx={{ textAlign: 'center', paddingY: '40vh', marginX: 'auto' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (isCoach) {
        return <AdminTeamView />;
    } else {
        return <TeamOverview />;
    }
}
